<loading [loading]="loading.isShow" [loadingMessage]="loading.message"></loading>

<div [hidden]="loading.isShow">
  <ng-container *ngIf="error_messages.length > 0">
    <ng-container *ngFor="let error_message of error_messages">
      <div class="alert alert-danger">
        <button type="button" class="close" data-dismiss="alert" (click)="removeErrorMessage(error_message)">
          ×
        </button>
        {{ error_message }}
      </div>
    </ng-container>
  </ng-container>

  <div *ngIf="refresh == true" class="alert alert-warning alert-dismissible fade show" role="alert">
    <strong>Reload!</strong> After editing and saving the template click the Reload button.
    <button type="button" class="btn btn-warning" (click)="reload_view()">Reload</button>
  </div>
  <div [hidden]="edit_document">
    <section
      role="dialog"
      tabindex="-1"
      class="slds-modal_large"
      aria-labelledby="id-of-modalheader-h2"
      aria-describedby="modal-content-id-1"
    >
      <div class="slds-modal__container">
        <header class="slds-modal__header">
          <h2 id="id-of-modalheader-h2" class="slds-text-heading_medium">Templates</h2>
        </header>
        <div class="slds-modal__content slds-p-around_medium" id="modal-content-id-1">
          <div class="row">
            <div class="col-md templates-container">
              <div class="panel panel-default panel-table">
                <div class="panel-heading">
                  <div class="row">
                    <div class="col">
                      <input
                        type="text"
                        (keyup)="search_templates(search.value)"
                        class="sn-sf-input"
                        id="search"
                        placeholder="Search SignNow Templates"
                        #search
                      /><span class="glyphicon glyphicon-search search-icon"></span>
                    </div>
                  </div>
                </div>
                <div class="panel-body">
                  <div class="scrolling">
                    <table class="table table-bordered table-list" id="TemplateTable" #TemplatesTable>
                      <tbody>
                        <ng-container *ngFor="let folder of folders">
                          <tr *ngIf="folder.documents?.length">
                            <td colspan="4">
                              <span class="glyphicon glyphicon-folder-open"></span>{{ folder.name }}
                            </td>
                          </tr>
                          <ng-container *ngFor="let document of folder.documents; let i = index">
                            <tr [attr.data-index]="i">
                              <td>
                                <a (click)="documentNamePopup(document)" href="javascript:void(0);">
                                  <span class="folder-name"
                                    ><span class="glyphicon glyphicon-file ml20"></span
                                    >{{ document.document_name }}</span
                                  >
                                </a>
                              </td>
                              <td>{{ document.owner }}</td>
                              <td data-label="Template Options" class="dropdown-templates">
                                <div title="Template Options">
                                  <!--
                                <div class="dropdown">
                                  <input id="toggle{{i}}" #toggle{{i}} type="checkbox">
                                  <label for="toggle{{i}}" class="animate">
                                    Select An Option &nbsp; <i class="fa fa-angle-down" aria-hidden="true"></i>
                                  </label>
                                  <ul class="animate">
                                    <li class="animate" (click)="documentSettingsString('edit', document)">Edit
                                      Template</li>
                                    <li class="animate" (click)="documentSettingsString('annotations', document)">Salesforce
                                      Annotations</li>
                                    <li class="animate" (click)="documentSettingsString('pushback', document)">Salesforce
                                      Data Binding</li>
                                  </ul>
                                </div>
                                -->
                                  <select
                                    class="sn-sf-input full-width"
                                    id="selectElem"
                                    #selectElem
                                    (change)="documentSettings(selectElem, document)"
                                  >
                                    <option>Select An Option</option>
                                    <option value="edit">Edit Template</option>
                                    <option value="annotations">Salesforce Annotations</option>
                                    <option value="pushback">Salesforce Data Binding</option>
                                  </select>
                                </div>
                              </td>
                            </tr>
                          </ng-container>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <app-data-binding-popup-form
    *ngIf="is_show_pushback_popup"
    (hideAllModalsE)="hideAllModals()"
    (updateLoadingE)="updateLoadingEvent($event)"
    (addPushbackDataToDocumentE)="addPushbackDataToDocument()"
    (resetDataAndUpdateErrorE)="resetDataAndUpdateErrorEvent($event)"
    [recordType]="pushback_type"
    [isNeedShowForm]="display_pushback"
    [document]="selected_pushback_document"
    [sfObjectsSuggestionList]="sfObjectsList"
    [isUserOwnerOfDocument]="is_user_owner_of_selected_document"
  >
  </app-data-binding-popup-form>

  <sn-modal-popup [isShowModal]="document_popup">
    <ng-container class="sn-modal-header">
      <h2 class="slds-text-heading_medium slds-hyphenate">Generate new Document</h2>
    </ng-container>
    <ng-container class="sn-modal-content">
      <div class="form-group">
        <label
          for="DocumentNameInput"
          class="col-md-6 control-label"
          style="font-size: 0.9rem; margin-top: 5px"
        >
          Please enter document name:
        </label>
        <div class="col-md-6">
          <input
            type="text"
            class="sn-sf-input"
            id="DocumentNameInput"
            value="{{ selected_document_name }}"
            #DocumentNameInput
          />
        </div>
      </div>
    </ng-container>
    <ng-container class="sn-modal-footer">
      <button class="btn btn-primary" (click)="cloneTemplate(DocumentNameInput.value)">Submit</button>
      <button class="btn btn-neutral" (click)="hideAllModals()">Cancel</button>
    </ng-container>
  </sn-modal-popup>

  <ng-container *ngIf="edit_document">
    <div class="slds-modal-wrap">
      <div
        role="dialog"
        tabindex="-1"
        aria-labelledby="modal-heading-01"
        class="slds-modal slds-fade-in-open"
        style="width: 100%; top: 0; bottom: 0; padding: 0"
      >
        <div style="width: 100%; max-width: 100%; height: 100%">
          <div class="slds-modal__content overhide" id="modal-content" style="height: 100%; width: 100%">
            <object width="100%" height="100%" [data]="edit_document_url"></object>
          </div>
        </div>
      </div>
      <!--<div class="slds-backdrop slds-backdrop_open"></div>-->
    </div>
  </ng-container>
</div>
